/** legacy performance.navigation.type 与 Navigation Timing Level 2 的映射 */
const LEGACY_NAVIGATION_TYPE_MAP = {
  0: 'navigate',
  1: 'reload',
  2: 'back_forward',
  255: 'navigate',
};

/**
 * 获取页面导航类型，兼容新旧 API
 * @returns {'navigate'|'reload'|'back_forward'|'prerender'|''}
 */
export const getNavigationType = () => {
  if (typeof performance === 'undefined') {
    return '';
  }
  try {
    if (typeof performance.getEntriesByType === 'function') {
      const navEntry = performance.getEntriesByType('navigation')[0];
      if (navEntry?.type) {
        return navEntry.type;
      }
    }
  } catch {
    // ignore
  }
  try {
    const legacyType = performance.navigation?.type;
    if (legacyType !== undefined && legacyType !== null) {
      return LEGACY_NAVIGATION_TYPE_MAP[legacyType] || '';
    }
  } catch {
    // ignore
  }
  return '';
};

export const safeSessionStorageGetItem = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const safeSessionStorageSetItem = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const isPageShowPersisted = (event) => {
  return !!(event && event.persisted === true);
};

export const isNavigationTraverseEvent = (event) => {
  return !!(event && event.navigationType === 'traverse');
};

/**
 * 注册生命周期监听，Navigation API 不可用时仅依赖 pageshow / popstate
 * @param {{ onPageShow: Function, onPopState: Function, onNavigate: Function }} handlers
 */
export const bindFlowLifecycleListeners = (handlers) => {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }
  const { onPageShow, onPopState, onNavigate } = handlers || {};
  if (typeof onPageShow === 'function') {
    window.addEventListener('pageshow', onPageShow);
  }
  if (typeof onPopState === 'function') {
    window.addEventListener('popstate', onPopState);
  }
  if (typeof onNavigate !== 'function') {
    return;
  }
  const navigation = window.navigation;
  if (!navigation || typeof navigation.addEventListener !== 'function') {
    return;
  }
  try {
    navigation.addEventListener('navigate', onNavigate);
  } catch {
    // Navigation API 不可用或权限受限
  }
};
